import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { BettingLimitReachedRealTimeMessagePayload } from "@obg/common.realtime-notifications";

@Component({
	selector: "obg-zhh-betting-limits-alert-container",
	templateUrl: "./zhh-betting-limits-alert.container.html",
	styleUrls: ["./zhh-betting-limits-alert.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ZhhBettingLimitsAlertContainer {
	constructor(@Inject(MAT_DIALOG_DATA) public data: BettingLimitReachedRealTimeMessagePayload) {}

	getTitleText(): string {
		return `responsible-gaming.${this.mapLimitPeriod(this.data.LimitPeriod)}-${this.mapLimitType(
			this.data.LimitType
		)}.${this.data.ProductCategories[0]}.title`;
	}

	getMessageText(): string {
		return `responsible-gaming.${this.mapLimitPeriod(this.data.LimitPeriod)}-${this.mapLimitType(
			this.data.LimitType
		)}-${this.data.ProductCategories[0]}.message`;
	}

	getSubtext(): string {
		return `responsible-gaming.${this.mapLimitPeriod(this.data.LimitPeriod)}-${
			this.data.ProductCategories[0]
		}-limit-reached.subtext`;
	}

	mapLimitType(limitType: string): string {
		switch (limitType) {
			case "BettingLimit":
				return "betting-limit";
			case "NetLossLimit":
				return "net-loss-limit";
			default:
				return "";
		}
	}

	mapLimitPeriod(limitPeriod?: string): string {
		switch (limitPeriod) {
			case "Monthly":
				return "monthly";
			case "Daily":
				return "daily";
			default:
				return "";
		}
	}
}
